"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PipIconBase = exports.PipIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var PipIcon = _styledComponents["default"].span.withConfig({
  displayName: "PipIcon",
  componentId: "sc-1908wxj-0"
})(["display:inline-block;background:url(https://s3.amazonaws.com/gcc-media-assets/Blinds/PipFigurator/pip-icons-set.svg);text-indent:-999em;font-size:0;position:relative;zoom:1;transform:scale(0.7) translate(50%);float:left;margin-right:20px;top:4px;width:42px;height:42px;&.responsive{top:0;@media (max-width:575.98px){width:45px;height:45px;position:absolute;transform:scale(1) translate(0%);left:20px;top:10px;margin:0;}}"]);
exports.PipIcon = PipIcon;
var PipIconBase = _styledComponents["default"].span.withConfig({
  displayName: "PipIcon__PipIconBase",
  componentId: "sc-1908wxj-1"
})(["display:inline-block;background:url(https://s3.amazonaws.com/gcc-media-assets/Blinds/PipFigurator/pip-icons-set.svg);width:42px;height:42px;&.responsive{@media (max-width:575.98px){width:45px;height:45px;zoom:1;position:absolute;}}"]);
exports.PipIconBase = PipIconBase;
var _default = PipIcon;
exports["default"] = _default;
//# sourceMappingURL=PipIcon.js.map